module.exports = __webpack_public_path__ + "static/media/IMG_3578.ff693443.jpg";